import { render, staticRenderFns } from "./GTUserMappingCreate.vue?vue&type=template&id=05e06252&scoped=true"
import script from "./GTUserMappingCreate.vue?vue&type=script&lang=js"
export * from "./GTUserMappingCreate.vue?vue&type=script&lang=js"
import style0 from "./GTUserMappingCreate.vue?vue&type=style&index=0&id=05e06252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e06252",
  null
  
)

export default component.exports